export interface IFetchStatus {
  status: number;
  loading: boolean;
}

export const CHAT_BOT_SET_MESSAGE = 'CHAT_BOT_SET_MESSAGE';
export const SET_SUGGESTED_QUESTIONS = 'SET_SUGGESTED_QUESTIONS';
export const SET_FETCH_STATUS = 'SET_FETCH_STATUS';
export const UPDATE_OPEN = 'UPDATE_OPEN';
export const CHAT_BOT_RESET = 'CHAT_BOT_RESET';

interface Message {
  role: string;
  text: string;
}

interface ChatBotState {
  Messages: Message[];
  SuggestedQuestions: string[];
  FetchStatus: IFetchStatus;
  Open: boolean;
}

const INITIAL_STATE: ChatBotState = {
  Messages: [
    {
      text: 'message.greeting\n\nmessage.intro\n\nmessage.support',
      role: 'bot'
    }
  ],
  SuggestedQuestions: [],
  FetchStatus: {
    status: 200,
    loading: false
  },
  Open: false
};

interface SetMessageAction {
  type: typeof CHAT_BOT_SET_MESSAGE;
  data: Message;
}

interface SetSuggestedQuestionsAction {
  type: typeof SET_SUGGESTED_QUESTIONS;
  data: string[];
}

interface SetFetchStatusAction {
  type: typeof SET_FETCH_STATUS;
  data: Partial<IFetchStatus>;
}

interface UpdateOpenAction {
  type: typeof UPDATE_OPEN;
  data: boolean;
}

interface ResetMessageAction {
  type: typeof CHAT_BOT_RESET;
}

type ChatBotActionTypes =
  | SetMessageAction
  | SetSuggestedQuestionsAction
  | SetFetchStatusAction
  | UpdateOpenAction
  | ResetMessageAction;

function ChatBotReducer(state: ChatBotState = INITIAL_STATE, action: ChatBotActionTypes) {
  switch (action.type) {
    case CHAT_BOT_RESET:
      return {
        ...state,
        Messages: INITIAL_STATE.Messages
      };

    case CHAT_BOT_SET_MESSAGE:
      return {
        ...state,
        Messages: [...state.Messages, action.data]
      };

    case SET_SUGGESTED_QUESTIONS:
      return {
        ...state,
        SuggestedQuestions: action.data
      };

    case SET_FETCH_STATUS:
      return {
        ...state,
        FetchStatus: {
          ...state.FetchStatus,
          ...action.data
        }
      };
    case UPDATE_OPEN:
      return {
        ...state,
        Open: action.data
      };
    default:
      return state;
  }
}

export function AddMessage(data: { text: string; role: string }): SetMessageAction {
  return { type: CHAT_BOT_SET_MESSAGE, data };
}

export function AddSuggestedQuestions(data: string[]): SetSuggestedQuestionsAction {
  return { type: SET_SUGGESTED_QUESTIONS, data };
}

export function AddFetchStatus(data: Partial<IFetchStatus>): SetFetchStatusAction {
  return { type: SET_FETCH_STATUS, data };
}

export function UpdateOpen(data: boolean): UpdateOpenAction {
  return { type: UPDATE_OPEN, data };
}

export function ResetMessage(): ResetMessageAction {
  return { type: CHAT_BOT_RESET };
}

export default ChatBotReducer;
